__turbopack_context__.v({
  "hero-media-content-image": "-6hdpG_hero-media-content-image",
  "hero-media-content-video": "-6hdpG_hero-media-content-video",
  "image": "-6hdpG_image",
  "video": "-6hdpG_video",
});
